import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17c92afe"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upg-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/upgrade-reg.png",
    alt: "upgrade registration"
  })
], -1))
const _hoisted_2 = { class: "heading-lg" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseWrapper = _resolveComponent("BaseWrapper")!

  return (_openBlock(), _createBlock(_component_BaseWrapper, { size: "xs" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('title')), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('text')), 1),
      _hoisted_3,
      _createVNode(_component_BaseButton, {
        class: "btn-primary",
        "data-cy": "upgrade-reg-btn",
        disabled: _ctx.isWaitingForMigrationResponse,
        onClick: _ctx.livongoRegistration
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('nextBtn')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }))
}